import { Theme } from '@mui/material/styles';

// 响应式宽度预设
export const responsiveWidth = {
  // 输入框宽度
  inputField: {
    xs: 70,
    sm: 100,
    md: 120,
  },
  // 小型输入框
  smallInput: {
    xs: 50,
    sm: 70,
    md: 90,
  },
  // 标准输入框
  standardInput: {
    xs: 100,
    sm: 150,
    md: 200,
  },
  // 大型输入框
  largeInput: {
    xs: 150,
    sm: 200,
    md: 300,
  },
  // 下拉菜单
  select: {
    xs: 80,
    sm: 120,
    md: 150,
  },
  // 表格单元格
  tableCell: {
    xs: 100,
    sm: 150,
    md: 200,
  },
};

// 响应式边距预设
export const responsiveSpacing = {
  // 小边距
  small: {
    xs: 1,
    sm: 2,
    md: 3,
  },
  // 中等边距
  medium: {
    xs: 2,
    sm: 3,
    md: 4,
  },
  // 大边距
  large: {
    xs: 3,
    sm: 4,
    md: 6,
  },
};

// 常用样式组合
export const commonStyles = {
  // 表格头部单元格样式
  headerCell: {
    backgroundColor: "#f5f5f5",
    fontWeight: 600,
    position: "sticky",
    left: 0,
    zIndex: 1,
    minWidth: { xs: "30px", sm: "90px" },
    maxWidth: { xs: "40px", sm: "150px" },
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    padding: { xs: "6px", sm: "16px" },
    fontSize: { xs: "0.6rem", sm: "1rem" },
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  // 表格内容单元格样式
  contentCell: {
    padding: { xs: "8px", sm: "16px" },
    maxWidth: { xs: "120px", sm: "300px" },
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    whiteSpace: "nowrap",
    wordWrap: "break-word",
    overflow: "visible",
    textOverflow: "clip",
    textAlign: "right",
    fontSize: { xs: "0.75rem", sm: "1rem" },
  },
  // 多行内容单元格样式
  multiLineCell: {
    padding: { xs: "8px", sm: "16px" },
    maxWidth: { xs: "120px", sm: "200px" },
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    overflow: "visible",
    textOverflow: "clip",
    textAlign: "right",
    fontSize: { xs: "0.75rem", sm: "1rem" },
  },
  // 输入框样式
  textField: {
    width: responsiveWidth.standardInput,
  },
  // 小型输入框样式
  smallTextField: {
    width: responsiveWidth.smallInput,
  },
  // 下拉菜单样式
  select: {
    minWidth: responsiveWidth.select,
  },
};

// 创建自定义样式钩子
export const createStyles = <T extends string>(
  styles: Record<T, any>
): Record<T, any> => styles;